import LegalLinks from './LegalLinks';

export default LegalLinks;
